/**
 * @generated SignedSource<<a96e41df1aef4129c92711b4e9bae867>>
 * @relayHash 078d7490b0e32c04c06ec9ee114c1d15
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 03d8ca3b906e633a6c083ef59059162a50ed2c23e54526b126020d5a455071da

import type { ConcreteRequest } from 'relay-runtime';
export type searchLoaderVirtualAgentEnabledV2Query$variables = {
  cloudId: string;
  helpCenterAri: string;
  isVaOnHcGAEnabled: boolean;
};
export type searchLoaderVirtualAgentEnabledV2Query$data = {
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly virtualAgentEnabled: boolean | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
  readonly virtualAgent?: {
    readonly virtualAgentAvailability: boolean | null | undefined;
  } | null | undefined;
};
export type searchLoaderVirtualAgentEnabledV2Query = {
  response: searchLoaderVirtualAgentEnabledV2Query$data;
  variables: searchLoaderVirtualAgentEnabledV2Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isVaOnHcGAEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "virtualAgentEnabled"
},
v5 = {
  "condition": "isVaOnHcGAEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "VirtualAgentQueryApi",
      "kind": "LinkedField",
      "name": "virtualAgent",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "containerId",
              "variableName": "helpCenterAri"
            }
          ],
          "kind": "ScalarField",
          "name": "virtualAgentAvailability"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "searchLoaderVirtualAgentEnabledV2Query",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "type": "HelpCenter"
              }
            ]
          }
        ]
      },
      (v5/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "searchLoaderVirtualAgentEnabledV2Query",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/)
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      },
      (v5/*: any*/)
    ]
  },
  "params": {
    "id": "03d8ca3b906e633a6c083ef59059162a50ed2c23e54526b126020d5a455071da",
    "metadata": {},
    "name": "searchLoaderVirtualAgentEnabledV2Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fb84e9b37fd41dce66a7b8b53fc81357";

export default node;
